module.exports = __webpack_public_path__ + "img/BG_blue2.81e98ea4.jpg";